<script>
    import {location, replace} from 'svelte-spa-router'

    export let tabs = [];
    export let activeIndex = 0;

    const tabChangeHandler = (index) => {
        activeIndex = index;
    }

    $: activeIndex === 0 ? replace($location) : replace(`${$location}?${tabs[activeIndex].label.toLowerCase()}`)

</script>

<style lang="scss" src="./ModalTabs.scss"></style>

<div class="ModalTabs">
    <ul class="ModalTabs__list">
        {#each tabs as tab, index}
            <li class="ModalTab__entry" class:active={index === activeIndex} on:click={() => tabChangeHandler(index)}>{tab.label}</li>
        {/each}
    </ul>
</div>